import { handleActions } from 'redux-actions';
import { produce } from 'immer';

import { SelectedSeatsState } from '../types';
import {
	AddSelectedSeatsAction,
	RemoveSelectedSeatsAction,
	SetSelectedSeatsBySegmentAction,
	addSelectedSeats,
	clearSelectedSeats,
	removeSelectedSeats,
	setSelectedSeatsBySegment
} from './actions';

const initialState: SelectedSeatsState = {};

const selectedSeatsReducer = handleActions<SelectedSeatsState, any>(
	{
		[addSelectedSeats.toString()]: (state, { payload }: AddSelectedSeatsAction) =>
			produce(state, draft => {
				draft[payload.segmentId] = {
					...draft[payload.segmentId],
					[payload.passengerId]: payload.seats.map(seat => ({
						...seat,
						segmentId: payload.segmentId,
						passengerId: payload.passengerId
					}))
				};
			}),
		[removeSelectedSeats.toString()]: (state, { payload }: RemoveSelectedSeatsAction) =>
			produce(state, draft => {
				delete draft[payload.segmentId]?.[payload.passengerId];
			}),
		[clearSelectedSeats.toString()]: () => initialState,
		[setSelectedSeatsBySegment.toString()]: (state, { payload }: SetSelectedSeatsBySegmentAction) => {
			return produce(state, draft => {
				draft[payload.segmentId] = payload.seats;
			});
		}
	},
	initialState
);

export default selectedSeatsReducer;
